import ErrorComponent from "components/shared/ErrorComponent";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { formatNumber } from "helpers/common";
import { useMemo } from "react";
import { Col, Row } from "react-bootstrap";

const SessionAttendence = ({ data }) => {
  const { absent, present, totalSessions } = data || {};
  return (
    <Row>
      <Col className="py-3 col-6 border-end">
          <div className="text-center py-3 px-3">
            <h6
              className="m-0 d-flex align-items-start justify-content-center themeBlue fw-bold"
              style={{ fontSize: 13 }}
            >
              <span
                className="icn me-1"
                style={{ color: " rgb(61, 160, 170)" }}
              >
                ■{" "}
              </span>{" "}
              Absent <span className="themeClr">({Math.round(absent?.percentage || 0)}%)</span>
            </h6>
            <p className="m-0 pt-2">{`${absent?.count || 0}/${totalSessions || 0} Sessions`}</p>
          </div>
      </Col>
      <Col className="py-3 col-6">
        <div className="text-center py-3 px-3">
          <h6
            className="m-0 d-flex align-items-start justify-content-center themeBlue fw-bold"
            style={{ fontSize: 13 }}
          >
            <span
              className="icn me-1"
              style={{ color: " rgb(61, 160, 170)" }}
            >
              ■{" "}
            </span>{" "}
            Present <span className="themeClr">({Math.round(present?.percentage || 0)}%)</span>
          </h6>
          <p className="m-0 pt-2">{`${present?.count || 0}/${totalSessions || 0} Sessions`}</p>
        </div>
      </Col>
    </Row>
  )
}

export default SessionAttendence;